import Dispatcher from '../../dispatcher';

import {
    COMMENTS_LOADED,
    COMMENTS_REPLY_ACTIVE
} from '../../constants';

/**
 * @param {String} params.text
 * @param {String} params.type
 * @param {Number} params.id
 * @param {Number} params.rootParent
 * @param {Number} params.parent
 */
export function addComment(params) {
    fetch('/comments/create', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            type: params.type,
            text: params.text,
            id: params.id,
            rootParent: params.rootParent,
            parent: params.parent,
            _token: Exanimo.CSRF
        })
    }).then((response) => {

        if (response.status !== 200) {
            throw new Error();
        }

        document.location.reload(true);
    }).catch((err) => {
        console.log(err);
    });
}

/**
 * @param {String} params.type
 * @param {Number} params.id
 */
export function loadComments(params) {
    fetch(`/comments/?id=${params.id}&type=${params.type}`,{
        method: 'GET',
        credentials: 'same-origin'
    }).then((response) => {

        if (response.status !== 200) {
            throw new Error();
        }

        return response.json();
    }).then((data) => {
        Dispatcher.dispatch({
            type: COMMENTS_LOADED,
            data
        });
    }).catch((err) => {
        console.log(err);
    });
}

export function replyActive(id) {
    Dispatcher.dispatch({
        type: COMMENTS_REPLY_ACTIVE,
        id
    });
}